import Axios from "axios";
import { ServiceApi } from "./Api";

export class ServiceConfig {

    async GetConfig() {
        var servico = await ServiceApi._getUrl();
        return await ServiceApi.get(servico+'Api/Config/GetConfig');
    }


    async listarServicosOnDemandPortal() {
        try {
            const resp = await ServiceApi.post("api/Portal/PostListarEndpointsOnDemandPortal");
            return resp?.data ?? resp;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    async salvarServicosOnDemandPortal(itens) {
        try {
            const resp = await ServiceApi.post(
                "api/Portal/PostSalvarEndpointsOnDemandPortal",
                itens
            );

            return resp?.data ?? resp;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getEndpointOnDemand(unidadeId) {
        try {
            const servico = await ServiceApi._getUrl();
            const resp = await ServiceApi.post(
                "api/Portal/PostGetEndpointOnDemandByUnidade",
                { unidadeId }
            );


            return resp?.data ?? resp;
        } catch (err) {
            console.error("Erro ao buscar endpoint onDemand:", err);
            return null;
        }
    }


}